import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const useTrackPageView = () => {
  const location = useLocation();
const prevPathRef = useRef(null); // ✅ valid in JavaScript

  useEffect(() => {
    const sessionId =  getSessionId();
    const userId = localStorage.getItem("username") || "";
    const currentPath = location.pathname;

    const referrer = prevPathRef.current || "direct";

    axios
      .post("https://s3napi.s3nsoftware.com/api/visitorlog/track", {
        userAgent: navigator.userAgent,
        pageVisited: currentPath,
        referrer: document.referrer || referrer,
        sessionId,
        userId,
      })
      .catch((err) => console.error("Tracking failed", err));

    // Store the current path as referrer for next page visit
    prevPathRef.current = currentPath;
  }, [location.pathname]); // runs on every route change
};

const getSessionId = () => {
  const sessionKey = "session_id";
  const sessionTimeKey = "session_time";

  const now = Date.now();
  const timeout = 20 * 60 * 1000; // 20 minutes

  const lastSessionTime = parseInt(sessionStorage.getItem(sessionTimeKey), 10) || 0;
  const expired = now - lastSessionTime > timeout;

  let sessionId = sessionStorage.getItem(sessionKey);

  if (!sessionId || expired) {
    sessionId = crypto.randomUUID();
  }

  sessionStorage.setItem(sessionKey, sessionId);
  sessionStorage.setItem(sessionTimeKey, now.toString());

  return sessionId;
};
export default useTrackPageView;
